import { session } from '../helpers/helpers';

const token = session.get('token');

export const getBlobFromUrl = (myImageUrl) => {
  // console.log('getBlobFromUrl started, URL:', myImageUrl);
  return new Promise((resolve, reject) => {
    fetch(myImageUrl, { method: 'GET', headers: { Authorization: 'Bearer ' + token } })
      .then((response) => {
        // console.log('getBlobFromUrl: fetch successful, status:', response.status);
        if (!response.ok) {
          // console.error('getBlobFromUrl: fetch failed, status:', response.status);
          reject(new Error(`Failed to fetch: ${response.status} ${response.statusText}`));
          return;
        }

        // Extract filename from Content-Disposition header
        const contentDisposition = response.headers.get('Content-Disposition');
        let filename = 'download';

        console.log('=== FRONTEND FILENAME EXTRACTION ===');
        console.log('Content-Disposition:', contentDisposition);

        if (contentDisposition) {
          // Try RFC 5987 format first (filename*=UTF-8''encoded_name)
          const rfc5987Match = contentDisposition.match(/filename\*=UTF-8''(.+?)(?:;|$)/i);
          console.log('RFC 5987 match:', rfc5987Match);

          if (rfc5987Match && rfc5987Match[1]) {
            filename = decodeURIComponent(rfc5987Match[1]);
            console.log('Using RFC 5987 filename:', filename);
          } else {
            // Fallback to regular filename parameter
            const filenameMatch = contentDisposition.match(/filename=["']?([^"'\n;]+)["']?/i);
            console.log('Regular filename match:', filenameMatch);

            if (filenameMatch && filenameMatch[1]) {
              filename = filenameMatch[1];
              console.log('Using regular filename:', filename);
            }
          }
        }

        console.log('Final filename:', filename);

        response.blob().then((data) => {
          // console.log('getBlobFromUrl: blob received, size:', data.size);
          resolve({ blob: data, filename });
        });
      })
      .catch((err) => {
        // console.error('getBlobFromUrl: fetch failed:', err);
        reject(err);
      });
  });
};

export const getDataFromBlob = async (myBlob, filename) => {
  // console.log('getDataFromBlob started, filename:', filename);
  try {
    const result = await new Promise((resolve, reject) => {
      const fileReader = new FileReader();
      fileReader.onload = () => resolve(fileReader.result);
      fileReader.onerror = () => reject(new Error('Error reading the file'));
      fileReader.readAsDataURL(myBlob);
    });

    // console.log('getDataFromBlob: file read successfully');

    // Створюємо посилання для завантаження
    const a = document.createElement('a');
    a.href = result;
    // Використовуємо ім'я файлу як є (вже декодоване в getBlobFromUrl)
    a.download = filename;
    a.click(); // Ініціюємо завантаження

    // console.log('getDataFromBlob: file download initiated');
  } catch (err) {
    console.error('getDataFromBlob: error:', err);
  }
};

const downloadFile = async (imageURL, fallbackFilename = 'receipt') => {
  // fallbackFilename is now optional and used only if server doesn't provide filename
  try {
    // console.log('downloadFile started, URL:', imageURL);
    const { blob, filename } = await getBlobFromUrl(imageURL);
    await getDataFromBlob(blob, filename || fallbackFilename);
    // console.log('downloadFile: file download initiated');
  } catch (err) {
    console.error('downloadFile: error:', err);
  }
};

export { downloadFile };
